<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Change Email</h3>
      <base-card class="tw-mt-4 tw-mb-6 tw-bg-yellow-100">
        <div class="tw-text-sm tw-text-gray-600">
          Changing a user's email is a big deal. It not only changes their email address but also their login and password. This should only be used when a user has been onboarded
          with the incorrect email.
        </div>
      </base-card>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-email-field class="tw-mt-2" label="New Email Address" placeholder="Enter the new email address" required v-model="emailAddress" />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4 sm:tw-mt-0">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error class="tw-mt-3" id="change-email-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  name: "ChangeEmail",
  components: {
    InlineError,
  },
  data() {
    return {
      userId: null,
      isLoading: false,
      isFormValid: true,
      emailAddress: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(userId) {
      this.userId = userId;
      this.$refs.modal.show();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      try {
        this.isLoading = true;
        await this.$axios.put(`/admin/users/${this.userId}/email`, {
          emailAddress: this.emailAddress,
        });
        this.$emit("save");
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Email Changed", message: `This user's email address was changed successfully` });
        this.hide();
      } catch (err) {
        this.errorTitle = `Error updating email address`;
        this.errorMessage = "Sorry, we had trouble changing this email address. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
